import React, { useState, useEffect, useContext } from 'react';
import { useIntl } from 'react-intl';
// General Utils
import { useNetwork } from 'services/network';
import { CartContext } from 'context/CartContextProvider';
import { backHomeLink } from 'utils/constants';
import translations from 'utils/translations';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';
// Components
import { SdmSpacer, SdmTypography } from 'components';
import {
  dataLayerPagesEnum,
  setVirtualPageDataLayer,
} from 'utils/dataLayerManager';
import { LoaderCountContext } from 'context/LoaderV5';

const CheckoutPage = ({ loggedUser, locale }) => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.Tickets(intl).checkoutStripe;
  const { setLoaderActive } = useContext(LoaderCountContext);
  const { orderNumber } = useContext(CartContext);
  const network = useNetwork();
  const location = useLocation();
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);
  const mediaTheme = useTheme();
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  // States
  const [clientSecret, setClientSecret] = useState('');
  // Effects
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    const createPaymentIntent = async () => {
      const paymentId = new URLSearchParams(window.location.search).get(
        'payment_id'
      );
      const _orderNumber = new URLSearchParams(window.location.search).get(
        'order_number'
      );
      const currentOrderNumber = location.state?.order_number;
      const path = window.location.pathname;
      const customUrl = `${backHomeLink}/${locale}${
        path?.includes('app') ? '/app' : ''
      }/sdm-tickets`;
      showLoader();
      const { session } = await network.generateStripeSession({
        orderNumber: currentOrderNumber || _orderNumber || orderNumber,
        paymentId,
        federationId: loggedUser?.salId,
        successUrl: `${customUrl}/success`,
        errorUrl: `${customUrl}/pending-order`,
      });
      if (session && session.url) {
        setVirtualPageDataLayer(dataLayerPagesEnum.TICKETS_CHECKOUT);
        window.location.href = session.url;
      } else {
        setClientSecret('000');
        setVirtualPageDataLayer(dataLayerPagesEnum.ERROR_ORDER);
      }
      hideLoader();
    };
    createPaymentIntent();
  }, [orderNumber]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {!clientSecret ? (
        <>
          <SdmSpacer height={isSmDown ? 80 : 150} />
          <SdmTypography variant={isSmDown ? 'h3' : 'fourtyFont'}>
            {i18n.preparing}
          </SdmTypography>
        </>
      ) : (
        <>
          <SdmSpacer height={150} />
          <SdmTypography variant={'h1'}>{i18n.error}</SdmTypography>
        </>
      )}
    </div>
  );
};

export default CheckoutPage;
